export default {
    IS_INACTIVE: 'is-inactive',
    IS_ENABLED: 'is-enabled',
    IS_INVISIBLE: 'is-invisible',
    IS_TRANSPARENT: 'is-transparent',
    FADE_IN: 'u-fade-in',
    FADE_OUT: 'u-fade-out',
    BUTTON_CLICKED: 'is-clicked',
    CV_CATEGORY: 'cv-category',
    STATS_CATEGORY: 'stats-category',
    CV_SKILL: 'skill',
    CV_WORK: 'work',
    CV_AMBITION: 'ambition',
    CV_SCHOOL: 'school',
    NEWS_FEED_ITEM: 'NewsList-item',
    ML_RESUME: 'Resume--ml',
    RESUME_ORANGE: 'Resume--orange',
    RESUME_BLUE: 'Resume--blue',
    PERSON_CARD: 'PersonCard',
    DATASET_GRID_ITEM: 'DatasetGrid-item',
    FULLSCREEN_ICON_EXPANDED: 'FullscreenIcon--expanded',
    VOLUME_ICON_OFF: 'VolumeIcon--off',
    ANIMATE_RESUME_ATTRIBUTES: 'animate-attributes',
    TRAINING_BACKGROUND: 'training-background',
    HIRING_TASK_DONE: 'hiring-task-done',
    FILE_PULSE: 'datafile-pulse',
    BREAKING_NEWS: 'breaking-news',
    ML: 'ml',
    OSCILLATE: 'u-oscillate',
    PULSATE: 'u-pulsate',
    CONVERSATION_STEP_COMPLETED: 'step-completed',
};
